/* @flow */
import { TrackingTags } from "shared/src/tracking/Tracking";
import { trackStructuredEvent } from "shared/src/utils/TrackingUtil";

export function trackOpenContentResult(
    originEventId: string,
    url: string,
    title: string,
    description: string | undefined | null,
    imageUrl: string | undefined | null
) {
    const hasDescription = Boolean(description);
    const hasImage = Boolean(imageUrl);
    const tags: TrackingTags = { originEventId, title, url, hasImage, hasDescription };
    trackStructuredEvent("content.open", { tags: tags });
}

export function trackContentView(
    eventId: string,
    url: string,
    title: string,
    description: string,
    imageUrl: string | undefined | null
) {
    const tags: TrackingTags = { eventId, url, title, description, hasImage: Boolean(imageUrl) };
    trackStructuredEvent("content.viewCard", { tags: tags });
}
